export default __webpack_public_path__ + "static/media/insertion.15eb5af6.jpg";